// extracted by mini-css-extract-plugin
export default {"inputWrapper":"LabelOutInput_inputWrapper__9P3Dr","hideLabel":"LabelOutInput_hideLabel__ED7QR","input":"LabelOutInput_input__+UhIQ"};